var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgStaffiSmallLogo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_90_25489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.770477 16.4998C0.770477 14.3329 1.19027 12.1874 2.00587 10.1855C2.82148 8.18361 4.01694 6.36466 5.52399 4.83249C7.03104 3.30033 8.82017 2.08495 10.7892 1.25574C12.7583 0.42654 14.8687 -0.000244494 17 -0.000244141V6.56955C15.7173 6.56955 14.4472 6.8264 13.2622 7.32544C12.0771 7.82448 11.0004 8.55593 10.0934 9.47804C9.18639 10.4001 8.46693 11.4948 7.97607 12.6996C7.48521 13.9044 7.23257 15.1957 7.23257 16.4998H0.770477Z",
    fill: "#3E7BF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.999 16.4998C16.999 14.3329 17.4258 12.1874 18.255 10.1855C19.0842 8.18361 20.2996 6.36466 21.8318 4.83249C23.3639 3.30033 25.1829 2.08495 27.1847 1.25574C29.1866 0.426541 31.3322 -0.000244235 33.499 -0.000244141V6.56955C32.195 6.56955 30.9037 6.8264 29.6989 7.32544C28.4941 7.82448 27.3994 8.55593 26.4773 9.47804C25.5552 10.4001 24.8237 11.4948 24.3247 12.6996C23.8257 13.9044 23.5688 15.1957 23.5688 16.4998H16.999Z",
    fill: "#11BCE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.999 16.4995C16.999 18.6663 16.5722 20.8119 15.743 22.8138C14.9138 24.8157 13.6985 26.6346 12.1663 28.1668C10.6341 29.6989 8.81517 30.9143 6.8133 31.7435C4.81143 32.5727 2.66583 32.9995 0.499022 32.9995V26.4297C1.80308 26.4297 3.09436 26.1729 4.29915 25.6738C5.50394 25.1748 6.59863 24.4433 7.52074 23.5212C8.44284 22.5991 9.1743 21.5044 9.67334 20.2996C10.1724 19.0948 10.4292 17.8036 10.4292 16.4995H16.999Z",
    fill: "#3E7BF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.229 16.4995C33.229 18.6663 32.8092 20.8119 31.9936 22.8138C31.178 24.8157 29.9826 26.6346 28.4755 28.1668C26.9685 29.6989 25.1793 30.9143 23.2103 31.7435C21.2412 32.5727 19.1308 32.9995 16.9995 32.9995V26.4297C18.2822 26.4297 19.5523 26.1729 20.7374 25.6738C21.9224 25.1748 22.9991 24.4433 23.9061 23.5212C24.8131 22.5991 25.5326 21.5044 26.0234 20.2996C26.5143 19.0948 26.7669 17.8036 26.7669 16.4995H33.229Z",
    fill: "#11BCE1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_90_25489"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.459,
    height: 33,
    fill: "white",
    transform: "translate(0.770508)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStaffiSmallLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/staffi-small-logo.77eca00b.svg";
export { ForwardRef as ReactComponent };